module.exports = __webpack_public_path__ + "img/MIDI-arpeggiator-plugin-vst-yellow.6f8f7198.png";